import { BrowserRouter } from "react-router-dom";
import { Container } from "./styles";
import ScrollAnimation from "react-animate-on-scroll";
import Illustration from "../../assets/illustration.svg";
import { NavHashLink } from "react-router-hash-link";
export function Hero() {
  return (
    <Container id="home">
      <div className="hero-text">
        <ScrollAnimation animateIn="fadeInUp">
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
          <h1>Tangled</h1>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.4 * 1000}>
          <h3>"Connecting minds, building unity with Tangled's immunity"</h3>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.6 * 1000}>
          <p className="small-resume">
            <em>
            Tangled's mission is to make mental health treatment more accessible and affordable for everyone.
             The platform offers a range of features, including virtual counseling, teletherapy, and self-help 
             resources, to meet the diverse needs of its users. Additionally, Tangled provides users with secure
              and encrypted communication to ensure the privacy and confidentiality of their medical records. 
              With Tangled, people can receive quality mental health care from the comfort of their own homes,
               reducing the barriers to accessing traditional therapy. Overall, Tangled's innovative approach to
                mental health treatment has the potential to significantly improve the lives of people suffering
                 from mental health issues.

            </em>
          </p>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" delay={0.8 * 1000}>
          <BrowserRouter>
            <NavHashLink smooth to="#about" className="button">
              Begin!
            </NavHashLink>
          </BrowserRouter>
        </ScrollAnimation>
      </div>
      <div className="hero-image">
        <ScrollAnimation animateIn="fadeInRight" delay={1 * 1000}>
          <img
            src={Illustration}
            alt="Ilustration"
            height="auto"
            width="500rem"
          />
        </ScrollAnimation>
      </div>
    </Container>
  );
}
